import { useState, useEffect } from 'react'
import AnimatedSpan from 'containers/animatedSpan/AnimatedSpan'
import { useDispatch, useSelector } from 'react-redux'
import { useRequest } from 'hooks/useRequest'
import { setProjects } from 'redux/features/projects/projectsSlice'
import moment from 'moment'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import Spinner from 'components/loader/Spinner'
import DefaultSelect from 'components/formElements/DefaultSelect'
import { setUsers } from 'redux/features/users/usersSlice'
import { roleIds } from 'utils/Constants'

const LeasingReport = () => {
	const [filterOptions, setFilterOptions] = useState({ isArchive: false, searchString: '', email: null })
	const { projects, users } = useSelector((state) => state)
	const { projectsData } = projects
	const { usersData } = users

	const [getProjects, getProjectsLoading] = useRequest()
	const [accountManagers, setAccountManagers] = useState([])
	const [getUsers] = useRequest()

	const dispatch = useDispatch()
	useEffect(() => {
		getProjects('/Project/GetAllProjects', { method: 'GET' }).then((res) => {
			if (res.data.ok) {
				dispatch(setProjects(res.data.result?.filter((r) => r.types.filter((t) => t.type == 'Leasing').length > 0)))
			}
		})
		getUsers('/Account/GetAllUsers', {
			method: 'GET',
		}).then((res) => {
			if (res.data.ok) {
				dispatch(setUsers(res.data.result))
			}
		})
		getUsers('/Account/GetAllUsers', {
			method: 'GET',
		}).then((res) => {
			if (res.data.ok) {
				setAccountManagers(res.data.result)
			}
		})
	}, [filterOptions.isArchive])

	const handleChnage = (e, name, array) => {
		if (name == 'isArchive') {
			setFilterOptions((prev) => ({ ...prev, [name]: e.value }))
		} else if (e == null || e.length == 0 || e.value == '') {
			setFilterOptions((prev) => ({ ...prev, [name]: null }))
		} else {
			if (array) {
				setFilterOptions((prev) => ({
					...prev,
					[name]: e && e != undefined ? e : e.length > 0 && e,
				}))
			} else {
				setFilterOptions((prev) => ({
					...prev,
					[name]: e.value && e.value != undefined ? e.value : e.length > 0 && e[0].value,
				}))
			}
		}
	}
	const filteredProjects = [...projectsData]?.sort((a, b) => {
		if (a.leasingEnd == null) {
			return -1
		}
		if (b.leasingEnd == null) {
			return 1
		}
		return moment(a.leasingEnd).unix() < moment(b.leasingEnd).unix() ? -1 : 1
	}).filter((d) => {
		const keys = Object.keys(filterOptions)
		let rt = [true]
		if (keys.length > 0) {
			keys.forEach((k) => {
				if (filterOptions[k] != null) {
					if (k == 'searchString') {
						let uniName = (d.name + d.customerName).toLowerCase()
						//console.log(uniName, filterOptions[k], "UNINAME");
						rt.push(uniName.match(filterOptions[k].toLowerCase()))
					} else if (k == 'am') {
						rt.push(d.projectRoles.filter(r => r.roleId == roleIds.accountManager).find((e) => filterOptions[k].map((e) => e.value).includes(e.userId)))
					} else if (k == 'pm') {
						rt.push(d.projectRoles.filter(r => r.roleId == roleIds.projectManager).find((e) => filterOptions[k].map((e) => e.value).includes(e.userId)))
					} else if (k == 'isArchive') {
						rt.push(true)
					} else {
						rt.push(d.id == filterOptions[k])
					}
				}
			})
		}
		return rt.every((r) => r)
	})
	return (
		<AnimatedSpan className='page-container d-flex flex-column'>
			{getProjectsLoading ? (
				<div className='d-flex w-100 justify-content-center'>
					<Spinner size={3} />
				</div>
			) : (
				<div className='row'>
					<DataTable
						stripedRows
						className='col-md-12 p-1'
						emptyMessage='Hiç Kayıt Bulunamadı'
						size='small'
						responsiveLayout='stack'
						dataKey='id'
						header={() => (
							<div className='d-flex justify-content-between gap-3'>
								<div className='row flex-1'>
									<div className='col-md-2 pl-0'>
										<span className="p-input-icon-left ">
											<i className="pi pi-search" />
											<input
												type='text'
												placeholder='Proje/Müşteri Adı'
												className='default-input pl-5'
												name='searchString'
												onChange={(e) => handleChnage(e.target, 'searchString')}
											/>
										</span>
									</div>
									<div className='col-md-3'>
										<DefaultSelect
											handleChange={(e) =>
												handleChnage(
													e.map((p) => ({ ...p, name: 'am' })),
													'am',
													true
												)
											}
											placeholder='AM'
											isSearchable
											isMulti
											selectOptions={accountManagers.map((pt) => ({ label: `${pt.firstName} ${pt.lastName}`, value: pt.id }))}
										/>
									</div>
									<div className='col-md-3'>
										<DefaultSelect
											handleChange={(e) =>
												handleChnage(
													e.map((p) => ({ ...p, name: 'pm' })),
													'pm',
													true
												)
											}
											placeholder='PM'
											isSearchable
											isMulti
											selectOptions={usersData.map((pt) => ({ label: `${pt.firstName} ${pt.lastName}`, value: pt.id }))}
										/>
									</div>
								</div>
							</div>
						)}
						rowClassName={`table-hover `}
						rowExpansionTemplate={() => <div>Expansion</div>}
						value={filteredProjects}
					>
						<Column
							headerClassName='text-bold bg-primary text-default'
							className='text-semi-bold text-sm'
							style={{ width: 'auto', position: 'relative' }}
							field='name'
							header='Proje Adı'
							sortable='true'
							body={(rowData) => {
								const leasingEnd = moment(rowData.leasingEnd).format('YYYY-MM-DD')
								const today = moment(new Date(), 'YYYY-MM-DD')
								const isPassed = leasingEnd && moment(leasingEnd).diff(today, 'days') < 0
								const isNear = leasingEnd && moment(leasingEnd).diff(today, 'days') <= 30
								return (
									<div
										className={`text-sm cellSetTransparent ${!rowData.leasingEnd || isPassed ? 'bg-danger-dark' : isNear ? 'bg-warning' : 'cellSetTransparent'
											}`}
									>
										{rowData.customerName && `${rowData.customerName} -`} {rowData.name}
									</div>
								)
							}}
						/>
						<Column
							headerClassName='text-bold bg-primary text-default'
							className='text-semi-bold  text-sm'
							field='projectRoles'
							header='AM'
							style={{ width: '15%' }}
							body={(rowData) => {
								const leasingEnd = moment(rowData.leasingEnd).format('YYYY-MM-DD')
								const today = moment(new Date(), 'YYYY-MM-DD')
								const isPassed = leasingEnd && moment(leasingEnd).diff(today, 'days') < 0
								const isNear = leasingEnd && moment(leasingEnd).diff(today, 'days') <= 30
								return (
									<span
										className={`projects-list-card-footer-period cellSetTransparent text-sm ${!rowData.leasingEnd || isPassed ? 'bg-danger-dark' : isNear ? 'bg-warning' : 'cellSetTransparent'
											}`}
									>
										{rowData.projectRoles?.filter(r => r.roleId == roleIds.accountManager)?.map((r) => `${r.user.firstName} ${r.user.lastName}`).join(', ')}
									</span>
								)
							}}
						/>
						<Column
							headerClassName='text-bold bg-primary text-default'
							className='text-semi-bold  text-sm'
							field='projectRoles'
							header='PM'
							style={{ width: '15%' }}
							body={(rowData) => {
								const leasingEnd = moment(rowData.leasingEnd).format('YYYY-MM-DD')
								const today = moment(new Date(), 'YYYY-MM-DD')
								const isPassed = leasingEnd && moment(leasingEnd).diff(today, 'days') < 0
								const isNear = leasingEnd && moment(leasingEnd).diff(today, 'days') <= 30
								return (
									<span
										className={`projects-list-card-footer-period cellSetTransparent text-sm ${!rowData.leasingEnd || isPassed ? 'bg-danger-dark' : isNear ? 'bg-warning' : 'cellSetTransparent'
											}`}
									>
										{rowData.projectRoles?.filter(r => r.roleId == roleIds.projectManager)?.map((r) => `${r.user.firstName} ${r.user.lastName}`).join(', ')}
									</span>
								)
							}}
						/>
						<Column
							headerClassName='text-bold bg-primary text-default'
							className='text-semi-bold text-sm'
							field='leasingEnd'
							header='Leasing Bitiş Tarihi'
							sortable='true'
							style={{ width: 'auto' }}
							body={(rowData) => {
								const leasingEnd = moment(rowData.leasingEnd).format('YYYY-MM-DD')
								const today = moment(new Date(), 'YYYY-MM-DD')
								const isPassed = leasingEnd && moment(leasingEnd).diff(today, 'days') < 0
								const isNear = leasingEnd && moment(leasingEnd).diff(today, 'days') <= 30
								return (
									<span
										className={`projects-list-card-footer-period cellSetTransparent text-sm ${!rowData.leasingEnd || isPassed ? 'bg-danger-dark' : isNear ? 'bg-warning' : 'cellSetTransparent'
											}`}
									>
										{rowData.leasingEnd && <span> {moment(rowData.leasingEnd).format('LL')}</span>}
									</span>
								)
							}}
						/>
					</DataTable>
				</div>
			)}
		</AnimatedSpan>
	)
}
export default LeasingReport
